module.exports = __webpack_public_path__ + "img/item_industria.62e83fa3.svg";